import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import { TextInput } from "../components/FormComponents";
import {
	Button,
	ContentContainer,
	TitleHeader,
	NarrowContentWrapper,
	AlertMessage,
	FieldsLoading,
} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper,
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";
import { useUserIsReadOnly } from "../components/userFunctions";

const EditStudentPage = () => {
	const { state, dispatch, api } = useAppContext();
	useDocumentTitle("Edit Participant");
	const { studentId } = useParams();
	const [student, setStudent] = useState(null);
	const [loading, setLoading] = useState(true);
	const [updating, setUpdating] = useState(false);
	const [updated, setUpdated] = useState(false);
	const [validationErrors, setValidationErrors] = useState({});
	const [error, setError] = useState(null);
	let course = api.getCurrentCourse();
	const isReadyOnly = useUserIsReadOnly();

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		if (updated) {
			setTimeout(() => {
				setUpdated(false);
			}, 2000);
		}
	}, [updated]);

	async function fetchData() {
		const { data, error } = await api.fetchData(`/students/${studentId}`);
		if (data?.student) {
			dispatch({
				type: "SET_STUDENT_DETAILS",
				payload: {
					student: data.student,
					course_id: course.id,
					date_id: state.current_date_id,
				},
			});
			setStudent(data.student);
			setLoading(false);
		} else {
			if (error) {
				setError("Error fetching Participant details");
			} else {
				setError("Participant not found");
			}
			setLoading(false);
		}
	}

	async function handleSubmit(e) {
		e.preventDefault();
		setUpdating(true);
		setError(null);
		setValidationErrors({});
		setUpdated(false);

		// Validate form
		let errors = {};
		if (!student.first_name) {
			errors.first_name = "First Name is required";
		}
		if (!student.last_name) {
			errors.last_name = "Last Name is required";
		}

		if (Object.keys(errors).length) {
			setValidationErrors(errors);
			setUpdating(false);
			return;
		}

		const { data, error } = await api.fetchData(
			`/students/${studentId}`,
			"POST",
			{
				first_name: student.first_name,
				last_name: student.last_name,
				email: student.email,
			}
		);

		if (data?.success) {
			dispatch({
				type: "SET_STUDENT_DETAILS",
				payload: {
					student: data.student,
					course_id: course.id,
					date_id: state.current_date_id,
				},
			});
			setUpdating(false);
			setUpdated(true);
		} else {
			setError(error || data?.error || "An error occurred")
			setUpdating(false);
		}
	}

	function updateField(name, value) {
		setStudent({
			...student,
			[name]: value,
		});
	}

	return (
		<div className="edit-student-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title="Edit Student" />
					<NarrowContentWrapper>
						<div className="edit-student-form">
							{loading ? (
								<FieldsLoading />
							) : (
								<>
									{student && (
										<form action="">
											<div className="form-row">
												<div className="col-sm-6">
													<TextInput
														label="First Name"
														name="first_name"
														value={student.first_name}
														onChange={(e) => {
															updateField(
																"first_name",
																e.target.value
															);
														}}
														required={true}
														error={validationErrors?.first_name}
													/>
												</div>
												<div className="col-sm-6">
													<TextInput
														label="Last Name"
														name="last_name"
														value={student.last_name}
														onChange={(e) => {
															updateField(
																"last_name",
																e.target.value
															);
														}}
														required={true}
														error={validationErrors?.last_name}
													/>
												</div>
											</div>
											<TextInput
												label="Email Address"
												name="email"
												type="email"
												value={student.email}
												onChange={(e) => {
													updateField("email", e.target.value);
												}}
												error={validationErrors?.email}
											/>
											{error && (
												<AlertMessage
													type="danger"
													message={error}
												/>
											)}
											{updated && (
												<AlertMessage
													type="success"
													message="Participant details updated"
												/>
											)}
											<Button
												text={
													updating
														? "Updating Details..."
														: "Save Details"
												}
												type="primary"
												onClick={handleSubmit}
												disabled={updating || isReadyOnly}
												className="mt-3"
											/>
										</form>
									)}
									{!student && (
										<AlertMessage type="danger" message={error} />
									)}
								</>
							)}
						</div>
					</NarrowContentWrapper>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
};

export default EditStudentPage;
